const DEFAULT_API_BASE_URL = "https://learnsocialai.net/LearnSocialAI-api";

export const env = {
  apiBaseUrl: (process.env.REACT_APP_API_BASE_URL || DEFAULT_API_BASE_URL).replace(/\/+$/, ""),
  ipinfoLiteToken: (process.env.REACT_APP_IPINFO_LITE_TOKEN || "").trim(),
};
